import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Mail, User, Calendar, Key, Globe, Shield } from 'lucide-react';

const ProfilePage = () => {
  const { user, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-900"></div>
      </div>
    );
  }

  const profileFields = [
    { icon: Mail, label: 'Email', value: user?.email },
    { icon: User, label: 'Nickname', value: user?.nickname },
    { icon: Globe, label: 'Locale', value: user?.locale },
    { icon: Calendar, label: 'Last Updated', value: new Date(user?.updated_at).toLocaleDateString() },
    { icon: Key, label: 'User ID', value: user?.sub },
    { icon: Shield, label: 'Email Verified', value: user?.email_verified ? 'Yes' : 'No' }
  ];

  return (
    <div className="p-6 max-w-4xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Profile</h1>
        <p className="text-gray-600">Manage your profile information and settings</p>
      </div>

      {/* Profile Card */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        {/* Profile Header */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center space-x-4">
            <img
              src={user?.picture}
              alt={user?.name}
              className="w-20 h-20 rounded-full border-2 border-gray-200"
            />
            <div>
              <h2 className="text-xl font-semibold text-gray-900">{user?.name}</h2>
              <p className="text-gray-600">{user?.email}</p>
            </div>
          </div>
        </div>

        {/* Profile Information */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {profileFields.map((field, index) => {
              const IconComponent = field.icon;
              return (
                <div key={index} className="flex items-start space-x-3">
                  <div className="mt-1">
                    <IconComponent size={20} className="text-blue-900" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">{field.label}</p>
                    <p className="mt-1 text-sm text-gray-900">{field.value || 'Not provided'}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Footer with updated timestamp */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-lg">
          <p className="text-sm text-gray-600">
            Profile last updated: {new Date(user?.updated_at).toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;